import { render, staticRenderFns } from "./PersonalidadForm.vue?vue&type=template&id=cd37ef20&scoped=true&"
import script from "./PersonalidadForm.vue?vue&type=script&lang=js&"
export * from "./PersonalidadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd37ef20",
  null
  
)

export default component.exports